// extracted by mini-css-extract-plugin
export default {"privacy_screen":"Pagetransition_privacy_screen__92VgU"};